// extracted by mini-css-extract-plugin
export var content = "_5-3";
export var footer = "_5-4";
export var header = "_5-1";
export var panel = "_5-0";
export var tabsWrapper = "_5-2";